import React from "react";
import styled from "styled-components/macro";
import { toRem } from "theme/Breakpoints";
import { colors } from "theme/Theme";
import { MdArrowDropUp, MdArrowDropDown } from "react-icons/md";
import { growHeight } from "theme/Animations";
import { MenuItem } from "features/header/types";

interface DrawerNavExpandableProps {
  data: MenuItem;
  isExpanded: boolean;
  containerRef: React.RefObject<HTMLDivElement>;
  setExpandable: (i: number) => void;
}

const DrawerNavExpandable: React.FC<DrawerNavExpandableProps> = ({
  data,
  isExpanded,
  containerRef,
  children,
  setExpandable,
}) => {
  const onPress = () => {
    setExpandable(isExpanded ? 0 : data.id);
    containerRef.current!.scrollTo(0, 0);
  };

  return (
    <DrawerNavExpandableContainer>
      <DropDownBtn isActive={isExpanded} onClick={onPress}>
        <Title> {data.title}</Title>
        {isExpanded ? (
          <MdArrowDropUp color={colors.dark} size="2em" />
        ) : (
          <MdArrowDropDown color={colors.dark} size="2em" />
        )}
      </DropDownBtn>
      {isExpanded && <ExpandableSection>{children}</ExpandableSection>}
    </DrawerNavExpandableContainer>
  );
};

const DrawerNavExpandableContainer = styled.div`
  min-height: ${toRem(40)};
  display: flex;
  flex-direction: column;
  flex: 0 1 auto;
  justify-content: flex-start;
  overflow-y: hidden;
`;

const DropDownBtn = styled.div<{ isActive: boolean }>`
  min-height: ${toRem(40)};

  background-color: #eeeeee;
  margin-bottom: 1px;
  font-size: ${toRem(17)};
  font-weight: 500;
  border-left-style: solid;
  border-left-color: ${(props: any) =>
    props.isActive ? colors.light_blue : "#bbbbbb"};
  border-left-width: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  box-sizing: border-box;
`;

const Title = styled.div``;
const ExpandableSection = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  justify-content: flex-start;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none !important;
  animation: ${growHeight} 0.3s ease-in-out;
`;
export default DrawerNavExpandable;
